import React from "react";
import Select from "react-select";

const GeneralTab = () => {
  return (
    <div className="row">
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Importer
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Address
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Branch SNo
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="text"
              className="form-control form-control-sm"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            State
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="text"
              className="form-control form-control-sm"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            IE Code No
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="text"
              className="form-control form-control-sm"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            AD Code
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Regn. No
          </label>
          <div className="icon-forms d-flex gap-3 mb-3 mb-sm-0">
            <Select className="custom-selector " />
            <input type="text" className="form-control form-control-sm w-50" />
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Importer Ref No.
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input type="text" className="form-control form-control-sm w-50" />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Air Custodian
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Port of Shipment
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Country of Shipment
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Country of Origin
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Final Destination
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            B/E Heading
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input type="text" className="form-control form-control-sm" />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Quotation
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Sales Person
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Business Dimensions
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Payment Method
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Cleared Under RMS
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            UCR Type
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input type="text" className="form-control form-control-sm" />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            UCR No.
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input type="text" className="form-control form-control-sm" />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Ref. Type
          </label>
          <div className="icon-forms d-flex gap-3 mb-3 mb-sm-0">
            <Select className="custom-selector " />
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Doc Filing Status
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Transhipment
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Under Sec 46
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
          <input
            type="text"
            className="form-control form-control-sm"
            disabled
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            First Check
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
          <input
            type="text"
            className="form-control form-control-sm"
            disabled
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Green Channel
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
          <input
            type="text"
            className="form-control form-control-sm"
            disabled
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Kachha B/E
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
          <input
            type="text"
            className="form-control form-control-sm"
            disabled
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            Under Sec 48
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
          <input
            type="text"
            className="form-control form-control-sm"
            disabled
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            BE Number
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input type="text" className="form-control form-control-sm" />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
            BE Date
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
            />
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          High Sea Sale (Level 0)
          </label>
          <input type="checkbox" className="ms-2" name="Freight" id="Freight" />
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          Seller Name
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          Address
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
          <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          Branch SNo
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          IE Code No
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          City
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          Postal Code
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
            <input
              type="date"
              className="form-control form-control-sm"
              name="search_by"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          Country
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
          <Select className="custom-selector " />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="input_box_section">
          <label htmlFor="" className="form-label  mb-0">
          AD Code
          </label>
          <div className="icon-forms mb-3 mb-sm-0">
          <Select className="custom-selector " />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
